export const ACTIVE_PROJECT_CODE = process.env.REACT_APP_PROJECT_CODE || 'patliputra';

export const PROJECTS = {
    patliputra: {
        code: 'patliputra',
        name: 'Patliputra Logistics',
        shortName: 'Patliputra',
        pageTitle: 'Patliputra Logistics',
        domain: 'www.pplkore.com',
        establishedYear: '2013',
        logo: '/active_project/logo.png',
        sidebarBottom: '/active_project/sidebar_bottom.png',
        favicon: '/active_project/favicon.png',
        faviconType: 'image/png',
        loginBg: '/active_project/login-bg.webp',
        googleMapsKey: 'AIzaSyBgx1yexqw2p-Sbz4jLgFb_PzGAMC_vRJ0',
        description: 'Patliputra Logistics has emerged as a prominent player in the supply chain industry, offering comprehensive solutions for first and last-mile delivery, transportation, fleet management, and supply chain and logistics advisory.',
        copyright: 'Patliputra Logistics · All rights reserved',
        welcomeMessage: 'Welcome To Patliputra Logistics',
        loginHeadingLine1: 'We’re Here To Build',
        loginHeadingLine2: 'Something Great',
        loginFormHeading: 'Login',
        loginFormSubHeading: 'Client Panel',
        // ─── Brand Theme (logo se extracted: Steel Blue + Deep Navy) ───────────
        theme: {
            primary: '#3d6fa0',   // Steel Blue — logo icon
            primaryDark: '#1e3a5f',   // Deep Navy — logo text
            primaryLight: '#c5d9ee',   // Light blue — table headers, chips
            primaryLighter: '#eaf1f8',   // Very light — subtle backgrounds
            primaryText: '#ffffff',   // White — text on primary bg
            accent: '#2c5f8a',   // Accent — active/focus state
            accentHover: '#1e3a5f',   // Hover on accent
        },
        googleClientID: '276065480291-24g8stmb01ero8goetnefhb4nr0fofc4.apps.googleusercontent.com',
    },
    sagar: {
        code: 'sagar',
        name: 'Sagar Informatics Pvt. Ltd.',
        shortName: 'SIPL',
        pageTitle: 'Sagar Informatics',
        domain: 'www.sagarinformatics.com',
        establishedYear: '2007',
        logo: '/active_project/logo.png',
        favicon: '/active_project/favicon.ico',
        faviconType: 'image/x-icon',
        loginBg: '/active_project/login-bg.webp',
        googleMapsKey: 'AIzaSyBgx1yexqw2p-Sbz4jLgFb_PzGAMC_vRJ0',
        description: 'Sagar Informatics is a leading provider of innovative IT solutions, specialized in building robust software products, web development, and digital transformation for enterprises worldwide.',
        copyright: 'Sagar Informatics Pvt. Ltd. · All rights reserved',
        welcomeMessage: 'Welcome To Sagar Informatics',
        loginHeadingLine1: 'Innovative IT',
        loginHeadingLine2: 'Solutions',
        loginFormHeading: 'Welcome to SIPL',
        loginFormSubHeading: 'Client Panel',
        // ─── Brand Theme (logo se extracted: Bright Orange #ed721d) ──────────
        theme: {
            primary: '#ed721d',   // Bright Orange — exact logo color
            primaryDark: '#c45c10',   // Darker orange — hover/active
            primaryLight: '#fde8d4',   // Light orange — table headers, chips
            primaryLighter: '#fef6ee',   // Very light — subtle backgrounds
            primaryText: '#ffffff',   // White — text on primary bg
            accent: '#d4641a',   // Mid-orange — focus rings, accent UI
            accentHover: '#1a1a6e',   // Dark Navy — hover on accent
        },
    },
    Kambson: {
        code: 'Kambson',
        name: 'Kambson Logistics Expert',
        shortName: 'Kambson',
        pageTitle: 'Kambson Logistics Expert',
        domain: 'http://kambson.sagarinfotech.com',
        establishedYear: '',
        logo: '/active_project/logo.png',
        favicon: '/active_project/favicon.png',
        faviconType: 'image/png',
        loginBg: '/active_project/login-bg.webp',
        googleMapsKey: 'AIzaSyBgx1yexqw2p-Sbz4jLgFb_PzGAMC_vRJ0',
        description: 'Kambson Logistics Expert provides comprehensive logistics solutions with expertise in supply chain management, transportation, and delivery services.',
        copyright: 'Kambson Logistics Expert · All rights reserved',
        welcomeMessage: 'Welcome To Kambson Logistics',
        loginHeadingLine1: 'Leading Logistics',
        loginHeadingLine2: 'Forward',
        loginFormHeading: 'Sign in',
        loginFormSubHeading: 'Client Panel',
        // ─── Brand Theme (logo se extracted: Dark Navy #1a2744 + Golden #c49a3c) ─
        theme: {
            primary: '#1a2744',   // Dark Navy — logo text color
            primaryDark: '#0f1a2e',   // Deeper navy — hover/active
            primaryLight: '#d1dae8',   // Light navy — table headers, chips
            primaryLighter: '#eef2f7',   // Very light — subtle backgrounds
            primaryText: '#ffffff',   // White — text on primary bg
            accent: '#c49a3c',   // Golden — eagle icon color
            accentHover: '#a37e2e',   // Darker gold — hover on accent
        },
    }
};

/** Returns the active project config object */
export const getActiveProject = () => {
    return PROJECTS[ACTIVE_PROJECT_CODE] || PROJECTS.patliputra;
};

/** Returns the active project's theme object */
export const getActiveTheme = () => {
    return getActiveProject().theme;
};

